import { CREDIBILITY_STATS } from "@/lib/siteData";
import { Clock, CheckCircle2, Cog } from "lucide-react";

const ICONS = [Clock, CheckCircle2, Cog];

export const CredibilityStrip = () => {
  return (
    <section data-testid="credibility-strip" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
        {CREDIBILITY_STATS.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <div key={i} className="reveal flex gap-5 items-start" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="mt-1 shrink-0 w-11 h-11 flex items-center justify-center border border-gold/60 text-gold">
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <div>
                <div className="font-display text-3xl md:text-4xl leading-none tracking-tight">
                  {s.number}<span className="text-gold">{s.suffix}</span>
                </div>
                <div className="mt-2 text-sm md:text-base text-white/70 max-w-xs leading-relaxed">{s.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CredibilityStrip;
